import { useMemo } from "react";

const useCheckRequiredFieldsFilled = <T extends { toString: () => string }>(
  values: (T | undefined | null)[]
) => {
  // !null?.toString() === true
  // !undefined?.toString() === true
  // !"".toString() === true
  return useMemo(() => !values.some((value) => !value?.toString()), [values]); // toString to make 0 not falsy
};

export default useCheckRequiredFieldsFilled;
